<template>
  <div class="settings-page">
    <v-tabs v-model="tab" vertical>
      <v-tab
        v-for="(tab, index) in tabs"
        :key="index"
        @click="currentTab = tab.value"
        :disabled="tab.disabled"
        >{{ tab.text }}</v-tab
      >

      <v-tab-item :value="tab" :reverse-transition="false" :transition="false">
        <keep-alive>
          <component :is="currentTabComponent"></component>
        </keep-alive>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
  export default {
    name: "EditionsPage",
    components: {
      AccessoriesTab: () =>
        import("@/views/settings/components/AccessoriesTab.vue"),
      ColorsTab: () => import("@/views/settings/components/ColorsTab.vue"),
      SupportsTab: () => import("@/views/settings/components/SupportsTab.vue"),
      WorkforceTab: () =>
        import("@/views/settings/components/WorkforceTab.vue"),
      DevicesTab: () => import("@/views/settings/components/DevicesTab.vue"),
      OperationsTab: () =>
        import("@/views/settings/components/OperationsTab.vue")
      // PrintsTab: () => import("@/views/settings/components/PrintsTab.vue")
    },
    data() {
      return {
        tab: null,
        currentTab: "Accessories",
        tabs: [
          { text: "Accessoires", value: "Accessories" },
          { text: "Couleurs", value: "Colors" },
          { text: "Supports", value: "Supports" },
          { text: "Main d'oeuvre", value: "Workforce" },
          { text: "Type d'appareil", value: "Devices" },
          { text: "Type d'opération", value: "Operations" }
          // { text: "Impressions", value: "Prints" }
        ]
      };
    },
    computed: {
      currentTabComponent() {
        return this.currentTab + "Tab";
      }
    }
  };
</script>

<style lang="scss">
  .settings-page {
    height: 100%;
    .v-tabs {
      height: 100%;
      .v-tab {
        justify-content: flex-start;
      }
      .v-window {
        padding: 15px;
      }
    }
    .v-btn {
      background-color: #006064 !important;
      color: white;
    }
    .filters-container {
      background-color: #f0f0f0;
      padding: 30px;
    }
    .v-data-table {
      table {
        tr {
          background-color: white !important;
          &.v-row-group__header {
            background-color: rgba(132, 31, 99, 0.05) !important;
            .v-btn {
              display: none;
            }
          }
          &:not(.v-row-group__header) {
            td,
            th {
              &:not(:last-child) {
                border-right: 1px solid #707070;
              }
            }
          }
        }
      }
    }

    .selected {
      color: red !important;
    }
  }
</style>
